import React, { memo, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getWebsiteSetting } from "../../store/slices/user";
import styles from "./Marquee.module.css";

const Marquee = memo(({ variant = "default" }) => {
  const dispatch = useDispatch();
  const websiteSetting = useSelector((state) => state.user.websiteSetting);

  useEffect(() => {
    if (!Array.isArray(websiteSetting) || websiteSetting.length === 0) {
      dispatch(getWebsiteSetting());
    }
  }, [dispatch, websiteSetting]);

  const marqueeText = useMemo(() => {
    if (Array.isArray(websiteSetting) && websiteSetting.length > 0) {
      const text = websiteSetting[0]?.marqueeText;
      if (typeof text === "string" && text.trim()) {
        return text.trim();
      }
    }
    return "ยินดีต้อนรับเข้าสู่เว็บเดิมพันออนไลน์";
  }, [websiteSetting]);

  return (
    <div
      className={`${styles.marqueeContainer} ${
        variant === "header" ? styles.headerVariant : ""
      }`}
    >
      <div className={styles.marquee}>
        <div className={styles.marqueeContent}>
          <span className={styles.marqueeText}>{marqueeText}</span>
          <span className={styles.marqueeText}>{marqueeText}</span>
        </div>
      </div>
    </div>
  );
});

Marquee.displayName = "Marquee";

export default Marquee;
